module.exports = __webpack_public_path__ + "static/media/mbl_journal_empty.faefe666.svg";